(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forusnotthem-site-entrance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fun-site-entrance')) {
    customElements.define('fun-site-entrance', class extends HTMLElement {
      connectedCallback() {
        if (this.started || this.dataset.editor === 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.started = true;
        const key = 'forusnotthem-entrance-v2';
        try {
          if (this.dataset.replay === 'session' && sessionStorage.getItem(key)) return;
          sessionStorage.setItem(key, '1');
        } catch (error) {}
        this.hidden = false;
        this.finish = () => { this.hidden = true; clearTimeout(this.timer); };
        this.querySelector('button').addEventListener('click', this.finish);
        this.timer = setTimeout(this.finish, 3000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = event => { if (event.matches) this.finish(); };
        this.motion.addEventListener('change', this.onMotionChange);
        this.onPageShow = event => { if (event.persisted) this.finish(); };
        window.addEventListener('pageshow', this.onPageShow);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.motion) this.motion.removeEventListener('change', this.onMotionChange);
        if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
